import { render, staticRenderFns } from "./DPV.vue?vue&type=template&id=1dda4067"
import script from "./DPV.vue?vue&type=script&lang=js"
export * from "./DPV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports